// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.support_page_content {
    padding: 40px 20px;
    background-color: var(--gris-foncer);
    min-height: 100vh;
    font-family: 'Inter', sans-serif;
}

.support_header {
    text-align: center;
    max-width: 800px;
    margin: 0 auto 50px;
}

.support_header_icon {
    color: var(--couleur-principale);
    margin-bottom: 15px;
}

.support_header h1 {
    font-size: 2.5rem;
    font-weight: 800;
    color: var(--couleur-dark);
    margin-bottom: 10px;
}

.support_header_subtitle {
    color: #4B5563;
    font-size: 1.1rem;
}

.support_content {
    max-width: 1200px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 2fr 1fr;
    gap: 40px;
}

.support_faq_title {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 1.5rem;
    font-weight: 700;
    color: var(--couleur-dark);
    margin-bottom: 25px;
    padding-bottom: 10px;
    border-bottom: 3px solid var(--couleur-principale);
    width: fit-content;
}

.support_faq_title_icon {
    color: var(--couleur-principale);
}

.support_faq_item {
    background: var(--white-principale);
    border-radius: 10px;
    margin-bottom: 15px;
    overflow: hidden;
    border: 1px solid var(--white-secondaire);
    transition: box-shadow 0.2s;
}

.support_faq_item:hover {
    box-shadow: 0 4px 10px var(--gris-principale);
}

.support_faq_question {
    padding: 18px 25px;
    font-weight: 600;
    font-size: 1.05rem;
    color: var(--couleur-dark);
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    transition: background-color 0.2s;
}

.support_faq_item.open .support_faq_question {
    background-color: var(--white-secondaire);
    border-bottom: 1px solid var(--gris-secondaire);
}

.support_faq_arrow {
    transition: transform 0.3s ease;
    color: var(--couleur-principale);
}

.support_faq_arrow.support_faq_rotate_180 {
    transform: rotate(180deg);
}

.support_faq_answer_container{
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.4s ease-in-out;
}

.faq-answer-container-v8.active {
    max-height: 500px;
}

.support_faq_answer {
    padding: 15px 25px 20px 25px;
    color: #4B5563;
    line-height: 1.6;
    font-size: 0.95rem;
}

.support_contact_section {
    background: var(--white-principale);
    padding: 30px;
    border-radius: 10px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
    height: fit-content;
}

.support_contact_intro {
    font-size: 0.95rem;
    color: var(--gris-terciaire);
    margin-top: -10px;
    margin-bottom: 20px;
}

.support_contact_form_group {
    margin-bottom: 15px;
}

.support_contact_form_group label {
    display: block;
    font-weight: 600;
    color: var(--couleur-dark);
    margin-bottom: 6px;
    font-size: 0.9rem;
}

.input-field-v8 {
    width: 100%;
    padding: 10px 15px;
    border: 1px solid var(--gris-secondaire);
    border-radius: 8px;
    font-size: 0.95rem;
    color: var(--couleur-dark);
    transition: border-color 0.2s, box-shadow 0.2s;
}

.input-field-v8:focus {
    border-color: var(--couleur-principale);
    box-shadow: 0 0 0 3px rgba(255, 102, 0, 0.1);
    outline: none;
}

.textarea-v8 {
    resize: vertical;
}

.support_btn_send_message {
    width: 100%;
    padding: 12px;
    background-color: var(--couleur-principale);
    color: var(--white-principale);
    border: none;
    border-radius: 30px;
    font-weight: 600;
    font-size: 1rem;
    cursor: pointer;
    transition: background-color 0.2s, transform 0.1s;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    margin-top: 25px;
}

.support_btn_send_message:hover {
    background-color: var(--couleur-secondaire);
    transform: translateY(-1px);
}

.support_page_toast {
    position: fixed;
    top: 20px;
    right: 20px;
    background-color: var(--white-principale);
    border-left: 5px solid var(--vert-principale);
    padding: 15px 20px;
    border-radius: 8px;
    box-shadow: 0 4px 15px var(--gris-principale);
    display: flex;
    align-items: center;
    gap: 15px;
    z-index: 9000;
    animation: slideIn 0.5s ease-out forwards;
}

@keyframes slideIn {
    from { transform: translateX(100%); opacity: 0; }
    to { transform: translateX(0); opacity: 1; }
}

.support_toast_icon {
    color: var(--vert-principale);
    flex-shrink: 0;
}

.support_toast_title {
    font-weight: 700;
    color: var(--couleur-dark);
    margin: 0;
}

.support_toast_text {
    font-size: 0.9rem;
    color: var(--color-text);
    margin: 0;
}

@media (max-width: 900px) {
    .support_content {
        grid-template-columns: 1fr;
        gap: 30px;
    }
    
    .support_header h1 {
        font-size: 2rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/support/support.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,oCAAoC;IACpC,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;IAC1B,mBAAmB;IACnB,oBAAoB;IACpB,kDAAkD;IAClD,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,mCAAmC;IACnC,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,yCAAyC;IACzC,2BAA2B;AAC/B;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,0BAA0B;IAC1B,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iCAAiC;AACrC;;AAEA;IACI,yCAAyC;IACzC,+CAA+C;AACnD;;AAEA;IACI,+BAA+B;IAC/B,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,uCAAuC;AAC3C;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;IAC5B,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,mCAAmC;IACnC,aAAa;IACb,mBAAmB;IACnB,0CAA0C;IAC1C,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,wCAAwC;IACxC,kBAAkB;IAClB,kBAAkB;IAClB,0BAA0B;IAC1B,8CAA8C;AAClD;;AAEA;IACI,uCAAuC;IACvC,4CAA4C;IAC5C,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,2CAA2C;IAC3C,8BAA8B;IAC9B,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,iDAAiD;IACjD,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,2CAA2C;IAC3C,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,SAAS;IACT,WAAW;IACX,yCAAyC;IACzC,6CAA6C;IAC7C,kBAAkB;IAClB,kBAAkB;IAClB,6CAA6C;IAC7C,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,aAAa;IACb,yCAAyC;AAC7C;;AAEA;IACI,OAAO,2BAA2B,EAAE,UAAU,EAAE;IAChD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC/C;;AAEA;IACI,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;IACxB,SAAS;AACb;;AAEA;IACI;QACI,0BAA0B;QAC1B,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".support_page_content {\n    padding: 40px 20px;\n    background-color: var(--gris-foncer);\n    min-height: 100vh;\n    font-family: 'Inter', sans-serif;\n}\n\n.support_header {\n    text-align: center;\n    max-width: 800px;\n    margin: 0 auto 50px;\n}\n\n.support_header_icon {\n    color: var(--couleur-principale);\n    margin-bottom: 15px;\n}\n\n.support_header h1 {\n    font-size: 2.5rem;\n    font-weight: 800;\n    color: var(--couleur-dark);\n    margin-bottom: 10px;\n}\n\n.support_header_subtitle {\n    color: #4B5563;\n    font-size: 1.1rem;\n}\n\n.support_content {\n    max-width: 1200px;\n    margin: 0 auto;\n    display: grid;\n    grid-template-columns: 2fr 1fr;\n    gap: 40px;\n}\n\n.support_faq_title {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    font-size: 1.5rem;\n    font-weight: 700;\n    color: var(--couleur-dark);\n    margin-bottom: 25px;\n    padding-bottom: 10px;\n    border-bottom: 3px solid var(--couleur-principale);\n    width: fit-content;\n}\n\n.support_faq_title_icon {\n    color: var(--couleur-principale);\n}\n\n.support_faq_item {\n    background: var(--white-principale);\n    border-radius: 10px;\n    margin-bottom: 15px;\n    overflow: hidden;\n    border: 1px solid var(--white-secondaire);\n    transition: box-shadow 0.2s;\n}\n\n.support_faq_item:hover {\n    box-shadow: 0 4px 10px var(--gris-principale);\n}\n\n.support_faq_question {\n    padding: 18px 25px;\n    font-weight: 600;\n    font-size: 1.05rem;\n    color: var(--couleur-dark);\n    cursor: pointer;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    transition: background-color 0.2s;\n}\n\n.support_faq_item.open .support_faq_question {\n    background-color: var(--white-secondaire);\n    border-bottom: 1px solid var(--gris-secondaire);\n}\n\n.support_faq_arrow {\n    transition: transform 0.3s ease;\n    color: var(--couleur-principale);\n}\n\n.support_faq_arrow.support_faq_rotate_180 {\n    transform: rotate(180deg);\n}\n\n.support_faq_answer_container{\n    max-height: 0;\n    overflow: hidden;\n    transition: max-height 0.4s ease-in-out;\n}\n\n.faq-answer-container-v8.active {\n    max-height: 500px;\n}\n\n.support_faq_answer {\n    padding: 15px 25px 20px 25px;\n    color: #4B5563;\n    line-height: 1.6;\n    font-size: 0.95rem;\n}\n\n.support_contact_section {\n    background: var(--white-principale);\n    padding: 30px;\n    border-radius: 10px;\n    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);\n    height: fit-content;\n}\n\n.support_contact_intro {\n    font-size: 0.95rem;\n    color: var(--gris-terciaire);\n    margin-top: -10px;\n    margin-bottom: 20px;\n}\n\n.support_contact_form_group {\n    margin-bottom: 15px;\n}\n\n.support_contact_form_group label {\n    display: block;\n    font-weight: 600;\n    color: var(--couleur-dark);\n    margin-bottom: 6px;\n    font-size: 0.9rem;\n}\n\n.input-field-v8 {\n    width: 100%;\n    padding: 10px 15px;\n    border: 1px solid var(--gris-secondaire);\n    border-radius: 8px;\n    font-size: 0.95rem;\n    color: var(--couleur-dark);\n    transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.input-field-v8:focus {\n    border-color: var(--couleur-principale);\n    box-shadow: 0 0 0 3px rgba(255, 102, 0, 0.1);\n    outline: none;\n}\n\n.textarea-v8 {\n    resize: vertical;\n}\n\n.support_btn_send_message {\n    width: 100%;\n    padding: 12px;\n    background-color: var(--couleur-principale);\n    color: var(--white-principale);\n    border: none;\n    border-radius: 30px;\n    font-weight: 600;\n    font-size: 1rem;\n    cursor: pointer;\n    transition: background-color 0.2s, transform 0.1s;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    margin-top: 25px;\n}\n\n.support_btn_send_message:hover {\n    background-color: var(--couleur-secondaire);\n    transform: translateY(-1px);\n}\n\n.support_page_toast {\n    position: fixed;\n    top: 20px;\n    right: 20px;\n    background-color: var(--white-principale);\n    border-left: 5px solid var(--vert-principale);\n    padding: 15px 20px;\n    border-radius: 8px;\n    box-shadow: 0 4px 15px var(--gris-principale);\n    display: flex;\n    align-items: center;\n    gap: 15px;\n    z-index: 9000;\n    animation: slideIn 0.5s ease-out forwards;\n}\n\n@keyframes slideIn {\n    from { transform: translateX(100%); opacity: 0; }\n    to { transform: translateX(0); opacity: 1; }\n}\n\n.support_toast_icon {\n    color: var(--vert-principale);\n    flex-shrink: 0;\n}\n\n.support_toast_title {\n    font-weight: 700;\n    color: var(--couleur-dark);\n    margin: 0;\n}\n\n.support_toast_text {\n    font-size: 0.9rem;\n    color: var(--color-text);\n    margin: 0;\n}\n\n@media (max-width: 900px) {\n    .support_content {\n        grid-template-columns: 1fr;\n        gap: 30px;\n    }\n    \n    .support_header h1 {\n        font-size: 2rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
